// removed by extract-text-webpack-plugin
module.exports = {"dynamicDetailsHeader":"dynamicDetailsHeader__2CRf0","dynamicDetailsContent":"dynamicDetailsContent__8WCbj","splitLineVertical":"splitLineVertical__2Z9HV","title":"title__qVR8-","subTitle":"subTitle__F_f6g","activityDate":"activityDate__3iT4Z","content":"content__i6uUw","dynamicButtonGroup":"dynamicButtonGroup__2W-ym","dynamicButton":"dynamicButton__TkDBp"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/DynamicDetails/index.css
// module id = 1501
// module chunks = 0